import { render } from "./SubsidiariesDetails.vue?vue&type=template&id=2a17d5e7&scoped=true"
import script from "./SubsidiariesDetails.vue?vue&type=script&lang=js"
export * from "./SubsidiariesDetails.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\sthem\\source\\repos\\Insync\\Pamodzi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a17d5e7"]])

export default __exports__